import React from 'react';

export const CalculateSizeSvg: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.00293 13.3389C9.95719 13.3391 11.7552 12.2709 12.6895 10.5544"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3385 8.00328C13.3385 5.05653 10.9497 2.66772 8.00293 2.66772"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00302 2.66772C6.04877 2.66756 4.25079 3.73581 3.31641 5.45222"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66797 8.0033C2.66797 10.95 5.05678 13.3389 8.00352 13.3389"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.31641 5.45232C4.48272 3.30897 6.95446 2.22996 9.31918 2.83189C11.6839 3.43381 13.339 5.56325 13.3386 8.00338"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66797 8.0033C2.6676 10.4434 4.32265 12.5729 6.68737 13.1748C9.05209 13.7767 11.5238 12.6977 12.6901 10.5544"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.36644 5.45231H3.00879V3.09399"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6396 10.5544H12.9973V12.9128"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
